module.exports = __webpack_public_path__ + "img/error.e11aa366.svg";